import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=f9b2d620"
import script from "./Page404.vue?vue&type=script&lang=js"
export * from "./Page404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports